// extracted by mini-css-extract-plugin
export default {"form":"_02_Phone_form__XVFtF","root":"_02_Phone_root__MAkxW"};